import React, {useEffect} from 'react'
import {connect} from 'react-redux'
import {Redirect, Route, Router, Switch} from 'react-router-dom'
import Layout from '../layouts/Layout'
import {checkLoginStatus, loginAction} from '../redux/actions/auth/index'
import {setAppId} from '../redux/actions/customizer/index'
import {loadNavtigation, loadUserRoles} from '../redux/actions/navbar/'
import {IntlProviderWrapper} from '../utility/context/Internationalization'
import messages_en from '../assets/data/locales/en.json'
import messages_vi from '../assets/data/locales/vi.json'
import AccountSettings from '../pages/account-settings/AccountSettings'
import GeneralInfo from '../pages/general-info/GeneralInfo'
import LandingPage from '../pages/authentication/LandingPage'
import {LOGIN_STATUS} from '../configs/app-configs'
import LandingPage2 from '../pages/authentication/LandingPage2'
import {ToastContainer} from 'react-toastify'
import ConfirmAlert from '../components/ConfirmAlert'
import AppId from '../configs/appId'
import AutoLogin from "../pages/authentication/AutoLogin";

const AppRouter = (props) => {
  const {
    checkLoginStatus,
    appId,
    user,
    loginStatus,
    isAuthentication,
    authToken,
    children,
    loadNavtigation,
    loadUserRoles,
    setAppId,
    history,
    message
  } = props

  useEffect(() => {
    setAppId(appId)
    const urlParams = new URLSearchParams(document.location.search)
    const code = urlParams.get('code') || authToken
    const redirectUrl = urlParams.get('redirectUrl')
    if (code && loginStatus !== LOGIN_STATUS.SUCCESS) {
      checkLoginStatus(code, redirectUrl)
    }
    if (authToken) {
      loadNavtigation(appId)
      loadUserRoles()
    }
  }, [authToken])

  const setMessages = (message = {}) => {
    const newMessage = {}
    Object.keys(message).forEach((key) => {
      newMessage[appId + '.' + key] = message[key]
    })
    return newMessage
  }

  const appMessage = {
    en: {...messages_en, ...setMessages(message.en)},
    vi: {...messages_vi, ...setMessages(message.vi)}
  }

  const settingRoutes = [
    {path: 'account-info', component: AccountSettings},
    {path: 'change-password', component: AccountSettings},
    {path: 'terms-and-condition', component: GeneralInfo},
    {path: 'privacy-policy', component: GeneralInfo},
    {path: 'language', component: GeneralInfo},
    {path: 'contact', component: GeneralInfo}
  ]

  const landingPageRoutes = [
    {path: 'register' },
    { path: 'forgot-password' },
    { path: 'provide-new-password' },
    { path: 'reset-password' }
  ]

  const landingPage2Routes = [
    {path: 'create-password'},
    {path: 'complete-information'}
  ]

  return (
    <IntlProviderWrapper
      locale={
        user && user.userSettings
          ? user.userSettings.language.toLowerCase()
          : localStorage.getItem('language')
      }
      appMessage={appMessage}
    >
      <Router history={history}>
        <Switch>
          <Route
            path='/'
            render={(props) =>
              isAuthentication ? (
                <Layout {...{...props, appId}}>
                  <Switch>
                    {settingRoutes.map((item) => (
                      <Route
                        key={item.path}
                        path={`/${item.path}`}
                        render={() => <item.component activeTab={item.path}/>}
                      />
                    ))}
                    <Route path='/' render={() => children}/>
                  </Switch>
                </Layout>
              ) : (
                <Switch>
                  <Route
                    path='/yeu-cau'
                    component={AutoLogin}
                  />
                  {landingPageRoutes.map((item) => (
                    <Route
                      key={item.path}
                      path={`/${item.path}`}
                      render={() => <LandingPage activeTab={item.path}/>}
                    />
                  ))}
                  {landingPage2Routes.map((item) => (
                    <Route
                      key={item.path}
                      path={`/${item.path}`}
                      render={() => <LandingPage2 activeTab={item.path}/>}
                    />
                  ))}
                  {appId === AppId.ELITE_APP ? (
                    <Route path='/' render={() => children}/>
                  ) : (
                    <Redirect from='/' to='/yeu-cau'/>
                  )}
                  <Redirect from='/' to='/'/>
                </Switch>
              )
            }
          />
        </Switch>
      </Router>
      <ToastContainer
        hideProgressBar
        position='top-right'
        autoClose={5000}
        closeOnClick
        pauseOnHover
      />
      <ConfirmAlert/>
    </IntlProviderWrapper>
  )
}

const mapStateToProps = (state) => {
  return {
    isAuthentication: !!state.auth.authToken,
    authToken: state.auth.authToken,
    loginStatus: state.auth.loginStatus,
    user: state.auth.user
  }
}
export default connect(mapStateToProps, {
  checkLoginStatus,
  loadNavtigation,
  loadUserRoles,
  loginAction,
  setAppId
})(AppRouter)
